import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type SavedView, type SavedViewBody, createSavedView } from '../lib/saved-views-client.js';
import { savedViewsQueryKey } from './use-saved-views.js';

interface UseCreateSavedViewOptions {
  tenantReportId: string;
}

export function useCreateSavedView({ tenantReportId }: UseCreateSavedViewOptions) {
  const queryClient = useQueryClient();

  return useMutation<SavedView, Error, SavedViewBody>({
    mutationFn: (body: SavedViewBody) => createSavedView(tenantReportId, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: savedViewsQueryKey(tenantReportId) });
    },
  });
}
